// App交互桥接文件
const bridge = {
  // 判断当前环境
  isInApp() {
    return window.webkit || window.android;
  },

  // 调用App方法
  callApp(method, params = {}) {
    return new Promise((resolve, reject) => {
      if (window.webkit && window.webkit.messageHandlers) {
        // iOS
        window.webkit.messageHandlers[method].postMessage(params);
      } else if (window.android) {
        // Android
        if (typeof params === 'object') {
          params = JSON.stringify(params);
        }
        window.android[method](params);
      } else {
        reject('非App环境');
      }
    });
  },

  // 获取用户信息
  getUserInfo() {
    return this.callApp('getUserInfo');
  },

  // 分享
  share(params) {
    return this.callApp('share', params);
  },

  // 返回上一页
  goBack() {
    return this.callApp('goBack');
  },

  // 关闭webview
  closeWebView() {
    return this.callApp('closeWebView');
  },

  // 打开新页面
  openNewPage(url) {
    return this.callApp('openNewPage', { url });
  }
};

export default bridge; 